var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtAndDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m248.205 197.638-15.674-20.01-56.482 261.247 24.926-22.786z",
    fill: "#d4e1f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m295.574 351.837a6 6 0 0 0 -5.758 1.322l-2.4 2.2 109.934 32.69-6.073-7.753z",
    fill: "#d4e1f4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m430.94 50h-54.109a6 6 0 0 0 -6 6v54.109a6 6 0 0 0 6 6h24.314v5.161a144.977 144.977 0 0 1 -91.778 134.994l-75.274-96.1a6 6 0 0 0 -10.588 2.433l-20.3 93.878a145.124 145.124 0 0 1 -92.353-135.2v-5.161h24.314a6 6 0 0 0 6-6v-54.114a6 6 0 0 0 -6-6h-54.106a6 6 0 0 0 -6 6v54.109a6 6 0 0 0 6 6h17.8v5.161a157.128 157.128 0 0 0 101.782 147.07l-40.3 186.392a6 6 0 0 0 9.912 5.7l105.152-96.122 136.556 40.606a6 6 0 0 0 6.433-9.451l-101.333-129.377a156.969 156.969 0 0 0 96.083-144.818v-5.161h17.8a6 6 0 0 0 6-6v-54.109a6 6 0 0 0 -6.005-6zm-343.88 12h42.109v42.109h-42.109zm188.514 289.837a6 6 0 0 0 -5.758 1.322l-93.767 85.716 56.482-261.247 164.815 210.419zm149.366-247.728h-42.109v-42.109h42.109z",
    fill: "#2f55d4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtAndDesign);
export default __webpack_public_path__ + "static/media/art-and-design.278854500f38e60b531ed293125554b5.svg";
export { ForwardRef as ReactComponent };